import React, { useState } from "react";
import arrowDown from "../../assets/arrow-down-red.svg";
import stopHuman from "../../assets/stop-human.png";
import "./FAQ.css";

interface FAQItem {
  question: string;
  answer: string;
}



const FAQ_ITEMS: FAQItem[] = [
  {
    question: 'Quem pode participar da promoção?',
    answer: 'Podem participar as pessoas físicas maiores de 18 (dezoito) anos na data de participação na promoção, inscritas no Cadastro de Pessoas Físicas do Ministério da Fazenda (CPF), com número válido e regular junto à Receita Federal.'
  },
  {
    question: 'Qual é o período de participação da promoção?',
    answer: 'O período de participação da promoção é de 16/07/2026 a 07/12/2026.'
  },
  {
    question: 'Qual é a área de abrangência da promoção?',
    answer: 'A promoção tem abrangência em todo o território nacional.'
  },
  {
    question: 'Quais são os locais/canais participantes da promoção?',
    answer: 'Participam desta promoção o e-commerce, por meio do site: https://www.academiarafaeltoro.com.br/, e o canal de televendas, através do número (51) 99584-6131.'
  },
  {
    question: 'Quais são os produtos participantes desta promoção?',
    answer: 'Participam todos os cursos comercializados nos canais participantes, inclusive os já existentes e aqueles que venham a ser lançados no período da promoção, pela Academia Rafael Toro.'
  },
  {
    question: 'É necessário realizar alguma contratação para participar da promoção?',
    answer: 'Sim, é necessário adquirir qualquer um dos cursos comercializados nos canais participantes da promoção, de forma que, a cada R$ 1.000,00, o consumidor terá direito a UM NÚMERO DA SORTE para participar da promoção.'
  },
  {
    question: 'Como faço para participar da promoção?',
    answer: 'Para participar da promoção o consumidor deverá, obrigatoriamente:\na) contratar curso(s) oferecido(s) pela Academia Rafael Toro; \nb) confirmar o interesse em participar da promoção no momento da contratação do(s) curso(s).'
  },
  {
    question: 'O valor das contratações de cursos é cumulativo para aquisição de números da sorte?',
    answer: 'Não. A cada R$ 1.000,00 em uma contratação válida, será gerado 1 número da sorte. As frações excedentes aos múltiplos do valor de participação, bem como as contratações com valor inferior ao mínimo necessário, serão desprezadas para fins de participação.'
  },
  {
    question: 'O pagamento de parcelas durante a promoção garante a geração de números da sorte?',
    answer: 'Não. O pagamento de parcelas durante a promoção, por si só, não garante a geração de números da sorte. Para que os números da sorte sejam gerados, é necessário que a contratação seja válida, esteja dentro do período de participação, tenha o respectivo pagamento efetivamente confirmado e atenda aos demais critérios previstos no regulamento.'
  },
  {
    question: 'Existe um limite de participação nesta promoção?',
    answer: 'Não. Os consumidores poderão participar da promoção quantas vezes desejarem e tiverem direito, desde que atendam aos critérios de participação previstos no regulamento.\nFica esclarecido que a distribuição dos números da sorte poderá atingir a quantidade total de sua emissão antes do término do período de participação. Caso isso ocorra, a promoção será encerrada e tal informação será amplamente divulgada pelos mesmos meios que divulgaram a promoção.'
  },
  {
    question: 'Onde posso consultar meus números da sorte?',
    answer: 'Para consultar o(s) número(s) da sorte adquirido(s), acesse o site carona.academiarafaeltoro.com.br, no prazo de até 07 dias úteis após confirmar seu interesse em participar da promoção.'
  },
  {
    question: 'Não estou conseguindo visualizar meus números da sorte. O que devo fazer?',
    answer: 'Caso tenha contratado curso(s) e confirmar o interesse em participar da promoção no momento da contratação, e ainda assim, passado o prazo de até 07 dias úteis, houver dificuldade na localização do(s) número(s) da sorte adquirido(s), entre em contato através do e-mail: sac@academiarafaeltoro.com.br.'
  },
  {
    question: 'Se eu cancelar a minha contratação, continuarei participando da promoção?',
    answer: 'Se a contratação for cancelada, os números da sorte gerados a partir dela serão invalidados. Mas, se o participante tiver outras contratações válidas, ele continua participando normalmente e ainda pode realizar novas contratações, respeitando os critérios previstos no regulamento.'
  },
  {
    question: 'Qual a data da apuração e o prêmio que faz parte desta promoção?',
    answer: 'O sorteio será realizado no dia 16/12/2026, por meio da Loteria Federal, com a apuração do contemplado no dia 23/12/2026.\nSerá distribuído como prêmio 01 (um) cartão com crédito no valor de R$ 150.000,00 (cento e cinquenta mil reais), sem as funções de saque e transferência, válido por 180 dias, com sugestão de uso para aquisição de uma “Fiat Toro”.'
  },
  {
    question: 'Como saberei se fui contemplado na promoção?',
    answer: 'O nome do contemplado e o respectivo número da sorte serão divulgados no site carona.academiarafaeltoro.com.br, em até 30 dias contados da apuração.\nAlém disso, em caso de contemplação, o participante será comunicado por e-mail, WhatsApp, telefone ou direct do Instagram, no prazo de até 30 dias após a divulgação da contemplação. Nessa comunicação, o contemplado receberá as instruções para o recebimento do prêmio e terá o prazo de até 3 dias para envio dos documentos necessários, a fim de viabilizar e registrar a entrega da premiação.'
  },
  {
    question: 'Como faço para receber meu prêmio?',
    answer: 'O contemplado receberá seu prêmio em local indicado pela Promotora ou em seu domicílio, conforme acerto entre as partes, mediante assinatura do recibo de entrega.'
  },
  {
    question: 'Posso trocar meu prêmio por dinheiro?',
    answer: 'A Legislação Brasileira não permite que as premiações oriundas de Sorteios, Concursos, Vale-Brindes e Modalidades assemelhadas sejam pagas em dinheiro.'
  },
  {
    question: 'Tenho outras dúvidas sobre a promoção. O que devo fazer?',
    answer: 'As dúvidas serão resolvidas através do e-mail: sac@academiarafaeltoro.com.br.'
  }
];

export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  function handleToggle(index: number) {
    setOpenIndex((previous) => (previous === index ? null : index));
  }

  return (
    <section className="faq" id="duvidas">
      <div className="container faq__content">
        <div className="faq__left" data-reveal>
          <div className="faq__text">
            <h2 className="faq__title">Ainda com dúvidas?</h2>
            <p className="faq__subtitle">A gente responde!</p>
          </div>
          <div className="faq__image-container">
            <img
              className="faq__image"
              src={stopHuman}
              alt="Pessoa apontando para as perguntas frequentes"
            />
          </div>
        </div>

        <ul className="faq__list" data-reveal style={{ "--reveal-delay": "150ms" } as React.CSSProperties}>
          {FAQ_ITEMS.map((item, index) => {
            const isOpen = openIndex === index;
            return (
              <li key={index} className={`faq__item${isOpen ? " faq__item--open" : ""}`}>
                <button
                  className="faq__question"
                  onClick={() => handleToggle(index)}
                  aria-expanded={isOpen}
                >
                  <span>{item.question}</span>
                  <img
                    className="faq__arrow"
                    src={arrowDown}
                    alt=""
                    aria-hidden="true"
                  />
                </button>
                {isOpen && (
                  <p className="faq__answer">{item.answer}</p>
                )}
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
}
